import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Input from 'components/Input';
import TextButton from 'components/TextButton';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import './EditProfileModal.css';

const EditProfileModal = ({
  showEditModal,
  closeEditModal,
  onChange,
  handleSubmit,
  displayName,
  onlineEmail
}) => {
  const [newEmailConfirmation, setNewEmailConfirmation] = useState(onlineEmail);

  const emailsMatch = onlineEmail === newEmailConfirmation;
  const noDisplayName = !displayName.length;
  const noEmail = !onlineEmail.length;

  return (
    <Modal
      show={showEditModal}
      onHide={closeEditModal}
      backdrop={'static'}
      className="edit-profile-details-modal"
    >
      <Modal.Body>
        <div className="player-details-edit-modal-content">
          <h1 className="edit-modal-section-title">DISPLAY NAME</h1>
          <div className="edit-help-text-medium">
            Edit the name that other users will see when you chat or play games.
          </div>
          <Input
            className={`edit-input ${noDisplayName ? 'warning' : ''}`}
            label="New Display Name"
            value={displayName}
            name="displayName"
            onChange={onChange}
            placeholder="New Display Name"
          />
          {noDisplayName && (
            <div className="warning-text">*Display name required</div>
          )}
          <div className="edit-help-text-small">
            You should see the successful change immediately after closing this
            window.
          </div>
          <h1 className="edit-modal-section-title">EMAIL ADDRESS</h1>
          <div className="edit-help-text-medium">
            Edit the email address you use to log in to your account.
          </div>
          <Input
            className={`edit-input ${noEmail ? 'warning' : ''}`}
            label="New Email Address"
            value={onlineEmail}
            name="onlineEmail"
            onChange={onChange}
            placeholder="New Email Address"
          />
          {noEmail && <div className="warning-text">*Email Required</div>}
          <Input
            className={`edit-input ${!emailsMatch ? 'warning' : ''}`}
            label="Confirm New Email Address"
            value={newEmailConfirmation}
            name="onlineEmail"
            onChange={e => setNewEmailConfirmation(e.target.value)}
            placeholder="New Email Address"
          />
          {!emailsMatch && (
            <div className="warning-text">*Emails must match</div>
          )}
          <div className="edit-help-text-small">
            A confirmation email will be sent to your new email address to
            confirm the change. It may take a few minutes for this email to
            appear.
          </div>
          <div className="profile-save">
            <Button
              className="profile-save-btn"
              variant="green"
              onClick={handleSubmit}
              disabled={
                !emailsMatch || !displayName.length || !onlineEmail.length
              }
            >
              Save Changes
            </Button>
          </div>
        </div>
      </Modal.Body>
      <TextButton onClick={closeEditModal} className="close-modal-button">
        <img src={CloseIcon} alt="Close Dialog" />
      </TextButton>
    </Modal>
  );
};

export default EditProfileModal;
